import { useCallback, useEffect, useState } from "react";

export const useHelpScout = () => {
  const [isBeaconReady, setIsBeaconReady] = useState(false);

  useEffect(() => {
    const checkBeacon = () => {
      if (window.Beacon && typeof window.Beacon === "function") {
        setIsBeaconReady(true);
      }
    };

    checkBeacon();

    const interval = setInterval(() => {
      checkBeacon();
    }, 100);

    const timeout = setTimeout(() => {
      clearInterval(interval);
    }, 5000);

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, []);

  const openBeacon = useCallback(() => {
    if (window.Beacon) {
      window.Beacon("open");
    }
  }, []);

  const closeBeacon = useCallback(() => {
    if (window.Beacon) {
      window.Beacon("close");
    }
  }, []);

  const toggleBeacon = useCallback(() => {
    if (window.Beacon) {
      window.Beacon("toggle");
    }
  }, []);

  const identifyUser = useCallback(
    (userData: { name?: string; email?: string; company?: string }) => {
      if (window.Beacon) {
        window.Beacon("identify", {
          ...(userData.name && { name: userData.name }),
          ...(userData.email && { email: userData.email }),
          ...(userData.company && { company: userData.company }),
        });
      }
    },
    [],
  );

  const setSessionData = useCallback((data: Record<string, string>) => {
    if (window.Beacon) {
      window.Beacon("session-data", data);
    }
  }, []);

  return {
    isBeaconReady,
    openBeacon,
    closeBeacon,
    toggleBeacon,
    identifyUser,
    setSessionData,
  };
};
